import { handleResponseOld, makeGet, makePost } from './helpers';

/**
 * @category Notifications API
 * @see fetchSmsAlerts
 */
type FetchSmsAlertsParams = {
    authToken: string;
    deployment: string;
};

type FetchSmsAlertsResponse = {
    error: boolean;
    payload: [
        {
            alertTypeId: number;
            bidderId: number;
            deliveryType: string;
            name: string;
            subscribed: boolean;
        }
    ];
};

/**
 * makes GET request for SMS alert settings via Telegram service
 * @function fetchSmsAlerts
 * @category Notifications API
 * @param {FetchSmsAlertsParams}
 * @see https://telegram-DEPLOYMENT.liveauctioneers.com/alertPreferences
 */
const fetchSmsAlerts = ({ authToken, deployment }: FetchSmsAlertsParams) =>
    new Promise<FetchSmsAlertsResponse>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: '<NOTIFICATIONS-API>alertPreferences' });
        request.end((err: string, response: Object) => handleResponseOld({ err, reject, resolve, response }));
    });

/**
 * @category Notifications API
 * @see toggleSmsAlerts
 */
type ToggleSmsAlertsParams = {
    alertTypeId: number;
    deliveryType: string;
    subscribed: boolean;
} & FetchSmsAlertsParams;

/**
 * makes POST request to toggle SMS alert settings via Telegram service
 * @function toggleSmsAlerts
 * @category Notifications API
 * @param {ToggleSmsAlertsParams}
 * @see https://telegram-DEPLOYMENT.liveauctioneers.com/alertPreferences
 */
const toggleSmsAlerts = ({ alertTypeId, authToken, deliveryType, deployment, subscribed }: ToggleSmsAlertsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ authToken, deployment, path: '<NOTIFICATIONS-API>alertPreferences' });
        const query = { alertTypeId, subscribed };
        if (Boolean(deliveryType)) {
            // @ts-ignore
            query.deliveryType = deliveryType;
        }

        request.send([query]);
        request.end((err: string, response: Object) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchSmsAlerts,
    toggleSmsAlerts,
};
